import React, { useEffect, useState } from 'react';
import { ExternalLink as LinkIcon } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import {
  BackButton,
  CustomerCommentBox,
  CustomerRatingBox,
  Error,
  Loading,
  ViewTitle,
} from '@iarcpsu/emanufac-components/src/components';
import { CRM_TYPE } from '@iarcpsu/emanufac-constant';
import { Button, Card, CardContent, Chip } from '@mui/material';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

import * as actions from '../../redux/actions';

export default function MiniDetailCustomer({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const customer = useSelector((state) => state.customer);
  const customerComment = useSelector((state) => state.customerComment);
  const customerRating = useSelector((state) => state.customerRating);
  const me = useSelector((state) => state.me);
  const [size, setSize] = useState(10);
  const information = useSelector((state) => state.information);

  useEffect(() => {
    dispatch(actions.customerGet(id));
    return () => {};
  }, []);

  const customerCommentAll = async () => {
    try {
      dispatch(
        actions.customerCommentAll({
          page: 1,
          size,
          customer: id,
        }),
      );
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'ไม่สามารถดึงคอมเมนต์ถึงคู่ค้า/ลูกค้าค้นนี้ได้',
        text: error?.message,
      });
    }
  };

  const customerRatingAll = async () => {
    try {
      dispatch(actions.customerRatingAll({ customer: id, page: 1, size: 10 }));
    } catch (error) {
      console.error('Customer Rating All Error', error);
    }
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const handleSubmitComment = async (data) => {
    try {
      await dispatch(
        actions.customerCommentCreate({
          ...data,
          customer: id,
        }),
      );
      customerCommentAll();
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: error?.message,
      });
    }
  };

  useEffect(() => {
    customerCommentAll();
    customerRatingAll();
    return () => {};
  }, [size]);

  const handleDeleteComment = async (commentId) => {
    try {
      Swal.fire({
        icon: 'warning',
        title: 'ยืนยันการลบคอมเมนต์',
        showCancelButton: true,
        showConfirmButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await dispatch(actions.customerCommentDelete(commentId));
          customerCommentAll();
        }
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'ไม่สามารถลบได้',
        text: error?.message,
      });
    }
  };

  const handleUpdateRating = async (nextRating) => {
    try {
      Swal.fire({
        icon: 'warning',
        title: 'ยืนยันการอัพเดท Rating คู่ค้า/ลูกค้า',
        showCancelButton: true,
        showConfirmButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await dispatch(
            actions.customerPut(id, {
              rating: nextRating,
              employee: me?.userData?._id,
            }),
          );
          dispatch(actions.customerGet(id));
          customerRatingAll();
        }
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'ไม่สามารถลบได้',
        text: error?.message,
      });
    }
  };

  if (customer.isLoading || customer.rows) {
    return <Loading />;
  }
  if (!customer.isLoading && customer.isCompleted) {
    return (
      <div>
        <div>{renderTitle()}</div>
        <div>
          <BackButton />
        </div>
        <div className="my-2">
          <Card>
            <CardContent>
              <div className="flex justify-between">
                <div>
                  <div className="font-semibold">
                    {customer?.type_code || ''} {customer?.name || ''}
                  </div>
                  <div>
                    ประเภท: {customer.type?.name || ''}
                    <Chip
                      label={CRM_TYPE[customer?.status]?.description}
                      size="small"
                    />
                  </div>
                </div>
                <div>
                  <Link to={`/crm/customer/detail/${id}`}>
                    <Button endIcon={<LinkIcon size={16} />}>
                      ข้อมูลลูกค้าคู่ค้าฉบับเต็ม
                    </Button>
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        <div className="my-2">
          <CustomerRatingBox
            customer={customer}
            handleUpdateRating={handleUpdateRating}
            customerRating={customerRating}
          />
        </div>
        <div className="my-2">
          <CustomerCommentBox
            allowDelete={information?.setting?.crm?.allow_remove_comment}
            comment={customerComment}
            container
            handleDeleteComment={handleDeleteComment}
            handleSubmitComment={handleSubmitComment}
            size={size}
            setSize={setSize}
            showTitle
          />
        </div>
      </div>
    );
  }
  return <Error />;
}

MiniDetailCustomer.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

MiniDetailCustomer.defaultProps = {
  title: '',
  subtitle: '',
};
